<template>
    <div>
        <div class="topbar-history">
            <div class="wrapper-back" @click="clickback()">
                <img class="icon-back" src="../assets/history/Path 15@2x.png" />
            </div>
            {{lbl.purchase.Headline}}
        </div>
        <div class="container bg-history">
            <purchase-list
                :lbl="lbl"
                :listConfig="purchaseListConfig"
                :filterConfig="purchaseFilterListConfig"
                :busEvent="busHistory"
                :busModal="busModal"
                :isLoading="isLoading"
                @toggleLoading="toggleLoading($event)"
            ></purchase-list>
        </div>
        <keep-alive>
            <router-view class="new-router" :key="$route.fullPath" ></router-view>
        </keep-alive>
    </div>
</template>
<script>
import Vue from "vue";
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import DateTime from "@/helper/DatetimeHelper.js";
import PurchaseList from "@/components/history/PurchaseList.vue";
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
    PointListConfigBuilder
} from "@/service/config/HistoryConfigModel.js";

export default {
    name: "History",
    components: {
        PurchaseList
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isLoading: false,
            isLogin: false,
            profile: {},
            purchaseListConfig: {},
            purchaseFilterListConfig: {},
            pointListConfig: {},
            busHistory: new Vue(),
            busModal: new Vue()
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.profile = Account.getCacheProfile();
            this.user = Account.getCacheUser();
            this.trackScreen();
        });
        this.initialPurchase();
        //Vue.ga.screenName(this, "privilege_history");
        Vue.ga.event(this, "privilege_history", "view_campaign", "");
    },
    methods: {
        //even
        trackScreen: function () {
            var gtm = Account.getTrackViewGTM(this.user);
            Vue.ga.screenName(this, "privilege_history", gtm);
        },
        clickback: function () {
            this.targetPage = Account.getCacheCustom('BzbsTarget');
            var cachecampaignID = Account.getCacheCustom('campaignId');

            var gtm = {
                 "event_label": "back",
                 "timestamp": DateTime.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege_history", "click_buttons", gtm.event_label, null, gtm);

            if (this.targetPage) {
                var targetPath = "/" + this.targetPage + "?command=close";
                this.$router.push(targetPath);
            } else if (cachecampaignID) {
                var path = "/history?command=close";
                this.$router.push(path);
            } else {
                Account.setCacheCustom('categoryId',undefined);
                this.$router.push("/");

            }
        },
        initialPurchase: function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.purchaseListConfig)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },
        initialEarnPoint: function () {
            //initial config for api.
            var listConfig = new PointListConfigBuilder()
                .setDate('')
                .create();
            this.pointListConfig = listConfig;
        },
        initialExpiringPoint: function () {

        },
        //page method.
        switchLang: function(locale) {
             Account.apiUpdateProfileLocale(locale)
                .then(objProfile => {
                    if (objProfile) this.Profile = objProfile;

                    Locale.setLocale(locale);
                    this.lbl = Locale.getLbl();
                    this.busHistory.$emit('switchLang', { lang: locale });
                })
                .catch(() => {});
        },
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
            this.$router.push('/home');
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.bg-history {
    padding-top: 79px;
    background-color: $background-gray-color;
    min-height: 100vh;
}

.topbar-history {
    font-size: 26px;
    padding: 15px 0 7px 0;
    font-weight: 500;
    text-align: center;
    position: fixed;
    top: 0;
    width: 100%;
    display: inline-block;
    z-index: 2;
    background-color: white;


    .wrapper-back {
        width: 13px;
        position: absolute;
        left: 20px;
        top: 13px;

        .icon-back {
            width: 100%;
        }
    }
}
</style>
<style lang="scss">
.keep-home {
    overflow: hidden;
}
.new-router {
    position: absolute;
    .layout {
        display: block;
        position: fixed;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
</style>
